import React from 'react';

import { Mail, Calendar, Shield, Lock, Eye, FileText, AlertCircle, CheckCircle, Info } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
 

  // Desktop/Web Design - Full featured layout
  const WebDesign = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <div className="container mx-auto px-4 py-8 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-12">
          <div className="flex flex-col items-center text-center sm:flex-row sm:justify-center sm:text-left gap-4 mb-4">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Shield className="w-8 h-8 text-blue-600" />
              </div>
            </div>
            <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900">
              Privacy Policy
            </h1>
          </div>
          <div className="text-center">
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
              <Calendar className="w-4 h-4 mr-2" />
              Effective Date: 28/Nov/2025
            </div>
          </div>
        </div>

        {/* Policy Content */}
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="p-6 sm:p-8 lg:p-12 space-y-8">
              
              {/* Section 1 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">1. General</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">1.1</h3>
                        <p className="text-gray-700 leading-relaxed">
                          DuriApp website or Duri Mobile App ("we" or "us" or Duri) take the privacy of User (Duri user) information very seriously. Our Privacy Policy is designed to tell user about our practices regarding the collection, use and disclosure of information that user may provide via the <a href="https://www.DuriApp.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">www.DuriApp.com</a> Duri Mobile App and other associated partner websites, microsites and sub-sites (the "Site").
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">1.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          By using any Duri services we offer,users are consenting to the collection, use, and disclosure of that information about user in accordance with, and are agreeing to be bound by, this Privacy Policy.
                        </p>
                      </div>

                      {/*<div>*/}
                      {/*  <h3 className="text-xl font-semibold text-gray-800 mb-2">1.3</h3>*/}
                      {/*  <p className="text-gray-700 leading-relaxed">*/}
                      {/*    Duri complies with the Government of India DPDP Act 2023 (the "Act"), when processing personal data.*/}
                      {/*  </p>*/}
                      {/*</div>*/}
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 2 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Ways that we collect information</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.1</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          We may collect and process the following information or data (including personal information and information that can be uniquely identified with user) about user:
                        </p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.1. User e-mail address verification through onetime password (OTP);</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.2. A mobile phone number verification through onetime password (OTP);</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.3. A record of any correspondence between userand us;</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.4. A record of any ride bookings/hosting user have made.</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.5. user replies to any surveys or questionnaires that we may use for research purposes.</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.6. Information we may require from user when user report a problem with Duri.</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">2.1.7. Information about user which we may receive from other sources.</span>
                                                  </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <div className="text-gray-700 space-y-2">
                              <p>
                                2.1.8. Duri collects information that may be required at time of registration including user
                                name and gender and photo, and if user is a vehicle Owner certain information about user
                                Vehicle Registration and valid driving licenses.
                              </p>
                              <div>
                                <p className="font-semibold">
                                  2.1.8.1 Country Specific Identifications
                                </p>
                                <ul className="space-y-1 ml-4">
                                  <li className="flex items-center gap-2">
                                    <span className="font-medium">a.</span>
                                    <img
                                      src="/indianflag.png"
                                      alt="India flag"
                                      className="h-4 w-4 object-contain"
                                    />
                                    <span className="font-semibold">INDIA:</span>
                                    <span>AADHAAR Card Information</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We only collect such information when user choose to supply it to us. User may choose not to supply any personal information to us, but user may not be able to take advantage of all the services we offer without doing so.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.3</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Information is also gathered without user actively providing it, through the use of various technologies and methods such as Internet Protocol (IP) addresses and cookies. These methods do not collect or store personal information.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.4</h3>
                        <p className="text-gray-700 leading-relaxed">
                          An IP address is a number assigned to user computer by user Internet Service Provider (ISP), so user can access the Internet. It is generally considered to be non-personally identifiable information, because in most cases an IP address can only be traced back to user ISP or the large company or organization that provides user internet access (such as user's employer if you are at work).
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.5</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We use user's IP address to diagnose problems with our server, report aggregate information and determine the fastest route for user computer to use in connecting to our servers, and to administer and improve the site.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.6 Mobile Device Access</h3>
                        <p className="text-gray-700 leading-relaxed mb-2 font-semibold">
                          Access to Device Features
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Duri may request access to certain device features strictly for the purpose of providing core app functionality. These permissions are optional to user except where they are essential for a specific feature user choose to use.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-2 font-semibold">
                          Location
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Duri may access user device location only to provide location-based functionality within the application (for example, to show location-relevant information or services). Location data is used within the app and is not sold, rented, or shared with any third parties for marketing purposes. Location is used only for ride coordination and safety. Duri will not use location information for cross-app tracking or advertising, Firebase is used for backend communication, not for ads.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-2 font-semibold">
                          Camera
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Duri may request access to user device camera to allow you to capture and upload images or videos within the app (for example, for user profile or for other in-app features that you choose to use). Media captured through the camera is used only for the specific feature you selected and is not used for any unrelated purpose.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-2 font-semibold">
                          Files and Documents
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Duri may request access to user device storage to enable you to select and upload existing images, media files, or documents as part of the app features (for example, to attach a document or image to a request or form). We do not scan or access any other files on user device other than those you explicitly choose to upload.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Secure Storage and Temporary Async Storage: Duri will use secure storage of mobile device to store and access sensitive information and uses temporary memory like Async Storage to share the data during app navigation. Upon app closes the temporary memory will be flushed and when App uninstalled the secure storage data will also be flushed. Data stored in these tech formats is not accessible for any other apps running in the device.
                        </p>
                        <p className="text-gray-700 leading-relaxed">
                          User can choose to grant or deny these permissions. However, certain features of the app may not function correctly without the relevant permission. You can also manage or revoke these permissions at any time through user device settings.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 3 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Use</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">3.1</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          We may use this information to:
                        </p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.1. ensure that the content of the Duri is presented in the most effective manner for user;</span>
                          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.2. assist in making general improvements to the Site or App;</span>
                          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.3. carry out and administer any obligations arising from any agreements entered into between user and us;</span>
                          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.4. allow user to participate in features of the Site and other services;</span>
                          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.5. contact user and notify user about changes to the services we offer (except where user have asked us not to do this);</span>
                          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.6. Analyze how users are making use of the Duri for internal marketing and research purposes.</span>
                          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">3.1.7 Ensure that user comply with the Conditions and applicable law.</span>
                          </li>
                        </ul>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">3.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We will not resell user information to any third party nor use it for any third party marketing.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 4 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Sharing Sensitive user information</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.1</h3>
                        <p className="text-gray-700 leading-relaxed">
                          As part of our  Duri booking or hosting process and in order to provide our services, minimal information regarding user contact may be passed to a Co-Traveler (if user is a vehicle Owner) or to a vehicle Owner (if user is a Co-Traveler) to facilitate tracking.
                        </p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                                                 <b>Geo location:</b> As part of Duri functionality we may share geo location of user information to navigation providers like (google maps or Apple apps) to provide location specific app features.  
                        </p>
                    </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.3</h3>
                        <p className="text-gray-700 leading-relaxed">
                          If we are under a duty to disclose or share user personal data in order to comply with any legal obligation (for example, if required to do so by a court order or for the purposes of prevention of fraud or other crime or upon requisition made by government agencies);
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.4</h3>
                        <p className="text-gray-700 leading-relaxed">
                          In order to enforce any terms of use that apply to any of the Site, or to enforce any other terms and conditions or agreements for our Services that may apply;
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2 flex items-center gap-1">
                          4.1.5
                          
                        </h3>
                        
                        <p className="text-gray-700 leading-relaxed">
                          Not with standing anything contained herein or the terms & conditions, Duri hereby disclaims any liability arising from the verification of the IDs and other documents by third party service providers including but not limited to its accuracy, reliability, and originality;
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.6</h3>
                        <p className="text-gray-700 leading-relaxed">
                          for the purpose of maintaining internal quality, training and updating the customers about the Services of Duri.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.7</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Duri may moderate the messages user exchange. Duri will not sell, transfer, distribute, or disclose user communications to any third party without user consent, unless such disclosure is mandated under applicable laws.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">4.1.8</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Other than as set out above, we shall not disclose any of user personal information.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 5 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Cookies</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">5.1</h3>
                        <p className="text-gray-700 leading-relaxed">
                          A cookie is a piece of data stored locally on user computer and contains information about user activities on the Internet. The information in a cookie does not contain any personally identifiable information user submit to our site.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">5.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          On the Site, we use cookies to track users' progress through the Site, allowing us to make improvements based on usage data. We also use cookies if userlog in to one of our online services to enable userto remain logged in to that service. A cookie helps userget the best out of the Site and helps us to provide userwith a more customized service.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">5.3</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Once user close user browser, our access to the cookie terminates. user have the ability to accept or decline cookies. Most web browsers automatically accept cookies, but usercan usually modify user browser setting to decline cookies if userprefer. To change user browser settings, user should go to user advanced preferences.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">5.4</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We have a clear cookie notice on the home page of the website. If usercontinue to use the Site having seen the notice, then we assume userare happy for us to use the cookies described above.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">5.5</h3>
                        <p className="text-gray-700 leading-relaxed">
                          If user choose not to accept the cookies, this will not affect user access to the majority of information available on the Site. However, user will not be able to make full use of our online services.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 6 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Access to and correction of personal information</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">6.1</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We will take all reasonable steps in accordance with our legal obligations to update or correct personally identifiable information in our possession that user submit in Duri.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">6.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We take all appropriate steps to protect user personally identifiable information as user transmit user information from user computer to our Site or App and to protect such information for loss, misuse, and unauthorized access, disclosure, alteration, or destruction. We use leading technologies and encryption software to safeguard user data and operate strict security standards to prevent any unauthorized access to it.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">6.3</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Where user use passwords, usernames, or other special access features on this site, user also have a responsibility to take reasonable steps to safeguard them.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 7 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Other websites</h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">7.1</h3>
                        <p className="text-gray-700 leading-relaxed">
                          This Site (duriapp.com or green.duriapp.com) contains links and references to other websites. Please be aware that this Privacy Policy does not apply to those websites.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">7.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          We cannot be responsible for the privacy policies and practices of sites that are not operated by us, even if user access them via the Site. We recommend that user check the policy of each site user visit and contact its owner or operator if userhave any concerns or questions.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">7.3</h3>
                        <p className="text-gray-700 leading-relaxed">
                          In addition, if user came to this Site via a third party site, we cannot be responsible for the privacy policies and practices of the owners or operators of that third party site and recommend that usercheck the policy of that third party site and contact its owner or operator if user have any concerns or questions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 8 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">8. Transferring user information outside of Country</h2>
                    <div className="flex items-center gap-2 mb-2">
                      <img
                        src="/indianflag.png"
                        alt="India flag"
                        className="h-5 w-5 object-contain"
                      />
                      <span className="text-gray-800 font-semibold">India</span>
                    </div>
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">8.1</h3>
                        <p className="text-gray-700 leading-relaxed">
                          As part of the services offered to user through the Site, the information user provide to us shall NOT be transferred to, and stored at, countries outside of India. The information provided by user may be transferred to a third party if it is necessary for the performance of any contract between us and the said third party and only upon receipt of user explicit consent to data transfer. If we transfer user information outside of India in any way, we will take steps with the aim of ensuring that user privacy rights continue to be protected as outlined in this privacy policy and in accordance with applicable laws including but not limited to Information Technology Act, 2000 and the rules framed thereunder.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">8.2</h3>
                        <p className="text-gray-700 leading-relaxed">
                          If user use the Site while outside India, user information may be transferred outside India in order to provide user with those services.
                        </p>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">8.3</h3>
                        <p className="text-gray-700 leading-relaxed">
                         Duri complies with the Government of India DPDP Act 2023 (the "Act"), when processing personal data 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 9 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Notification of changes to our Privacy Policy</h2>
                    <p className="text-gray-700 leading-relaxed">
                      We will post details of any changes to our Privacy Policy on the Site to help ensure user is always aware of the information we collect, how we use it, and in what circumstances, if any, we share it with other parties.
                    </p>
                  </div>
                </div>
      </section>

              {/* Section 10 */}
      <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact us</h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
                      If at any time user would like to contact us with user views about our privacy practices, or with any enquiry relating to user's personal information, user can do so by way of our contact page or by mail to contact@hansaitechnosoft.com
                    </p>
                    <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 p-4 rounded-xl border border-emerald-200">
                      <div className="flex items-center space-x-3">
                        <Mail className="w-5 h-5 text-emerald-600" />
                        <div>
                          <p className="font-semibold text-emerald-900">DuriApp Support</p>
                          <a href="mailto:contact@hansaitechnosoft.com" className="text-emerald-700 hover:text-emerald-900 underline">
                          contact@hansaitechnosoft.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

            </div>
          </div>
        </div>

        {/* Back to Top Button */}
        <div className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8">
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition-all duration-300 flex items-center justify-center group"
          >
            <svg className="w-6 h-6 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );

  
  return  <WebDesign />;
};

export default PrivacyPolicy;
